import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.scroll-to-animate-section');
  if (!section) return;

  const animatedBox = section.querySelector('.animated-box-wrapper');
  const heading = section.querySelector('.ct-headline');
  const contentItems = animatedBox.querySelectorAll('.content-item');
  const meter = animatedBox.querySelector('.meter-counter-animation');
  const wrapper = meter.querySelector('.counter-values-wrapper');
  const counterValues = wrapper.querySelectorAll('.counter-value');

  const scrollPerStep = 1000;
  const counterHeight = 117;
  const totalSteps = Math.min(contentItems.length, counterValues.length);
  const totalScroll = scrollPerStep * (totalSteps + 1);

  gsap.set(animatedBox, { opacity: 0, y:200 });
  gsap.set(wrapper, { y: 0 });
  gsap.set(contentItems, { opacity: 0, y: 20 });
  gsap.set(contentItems[0], { opacity: 1, y: 20 });
  gsap.set(counterValues, { opacity: 0.3 });
  gsap.set(counterValues[0], { opacity: 1 });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'center center',
      end: `+=${totalScroll}`,
      scrub: true,
      pin: true,
      anticipatePin: 1,
    },
  });

  tl.to(animatedBox, { y: 0, opacity: 1, duration: 0.8 });
  tl.to(heading, {opacity: 0.5, duration: 0.3});

  for (let i = 1; i < totalSteps; i++) {
    tl.to(contentItems[i - 1], { opacity: 0, duration: 0.3 });
    tl.to(contentItems[i], { opacity: 1, y: 0, duration: 0.3 });

    tl.to(wrapper, { y: -counterHeight * i, duration: 0.4 });

    tl.to(
      counterValues,
      {
        opacity: (index) => (index === i ? 1 : 0.3),
        duration: 0.3, 
      },
      '>-0.1'
    );
  }
});
